import { curry, path } from "ramda"
import { isNotEmptyString, isNotNullOrEmpty, isString } from "../../validate"

export default curry((maxLength, { value: str, forminputdata }) => {
  const countryCode = isNotNullOrEmpty(forminputdata) ? path(["region", "country", "id"], forminputdata) : ""
  if (countryCode === "HKG") {
    if (!isString(str)) return false
    if (!isNotEmptyString(str)) return false
    if (maxLength && (str.length <= 0 || str.length > maxLength)) return false
    const charsForHKBRReg = /^\d{8}-\d{3}[a-zA-Z0-9-]*$/
    return !!str.match(charsForHKBRReg)
  }
  return true
})
